import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationContextService, RolePermissionService } from 'lib-core-shared';
import { ComponentBaseDirective, Mode } from '../../directives/component.directive';

@Component({
  selector: 'app-smart-view',
  templateUrl: './smart-view.component.html',
  styleUrls: ['./smart-view.component.scss']
})
export class SmartViewComponent extends ComponentBaseDirective implements OnInit, AfterContentInit {
  @Input() mode: Mode = Mode.new;
  @Input() saveCaption = 'Save';
  @Output() resetEvent = new EventEmitter<boolean>(true);
  @Output() submitEvent = new EventEmitter<FormGroup>(true);
  @Input() resetCaption: string = 'Reset';
  @Input() isCloseButtonRequired?: boolean;
  @Input() removeResetButton?: boolean;
  @Input() buttonContainerRequired?: boolean;
  @Input() smartViewUsedInModal?: boolean;
  @Input() smartViewUsedInForm?: boolean;
  @Input() formGroup!: FormGroup;
  @Input() overridePersmission = false;
  @Input() showButtons = true;
  submitButtonDisabled: boolean = true;
  isPublic: boolean = false;
 
  constructor(
    public roleService: RolePermissionService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public formBuilder: FormBuilder, 
    public modalService: NgbModal, 
    public applicationContext: ApplicationContextService) {
    super(activatedRoute, router, roleService, applicationContext);
    this.isPublic = this.applicationContext.isPublic();
  }
  ngAfterContentInit(): void {
    if (!this.overridePersmission) {
      if (this.mode === Mode.edit) {
        this.submitButtonDisabled = this.isPermissionUpdate() ? false : true;
      } else {
        this.submitButtonDisabled = this.isPermissionCreate() ? false : true;
      }
    }
    else {
      this.submitButtonDisabled = false;
    }
  } 

  public get captionSaveText() {
    return  this.mode === Mode.edit ? this.saveCaption.replace('Save', 'Update') : this.saveCaption.replace('Update', 'Save');
  }

  ngOnInit(): void {
    
  }
}
